import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const EPubDeleteModel = types
  .model("EPubDeleteModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch(ePubISBN) {
      Framework.sendEvent("DELETING_EPUB_DATA", { ePubISBN });
    },
    set(response) {
      let status = response.status;
      // let isbn = response.config.url.split("/")[3];
      let data;
      if (status === 204) {
        data = `The book(s) has been successfully deleted.`;
      } else {
        data = status;
      }
      applySnapshot(self, {
        res: data,
      });
    },
    reset() {
      applySnapshot(self, {
        res:"Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default EPubDeleteModel;
